/** Krankenversichertennummer (KVNR): 1 Großbuchstabe + 9 Ziffern, letzte Ziffer = Prüfziffer. */

export function normalizeKvnr(input: string): string {
  return input.toUpperCase().replace(/\s+/g, "");
}

/**
 * Prüfziffernverfahren wie im Prototyp (index.html:421-428):
 * Buchstabe → zweistellige Zahl (A=01 … Z=26), dann die ersten 10 Ziffern abwechselnd ×1/×2,
 * Produkte > 9 minus 9, Summe mod 10 = Prüfziffer.
 */
export function isValidKvnr(input: string): boolean {
  const k = normalizeKvnr(input);
  if (!/^[A-Z]\d{9}$/.test(k)) return false;
  const body = String(k.charCodeAt(0) - 64).padStart(2, "0") + k.slice(1, 9);
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let p = Number(body[i]) * (i % 2 === 0 ? 1 : 2);
    if (p > 9) p -= 9;
    sum += p;
  }
  return sum % 10 === Number(k[9]);
}
